const apiVersion = 'v1'

export const BASE_PATH = `api/${apiVersion}/clients/:client_session_id/columns/`
export const BASE_SOURCE_COLUMNS_PATH = `api/${apiVersion}/clients/:client_session_id/sources/:source_id/columns/`
